<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>To the mother of my children, Belinda, I dedicate this story. Through all the ups and downs, bonds are formed and a life of memories made. Adversity brings strength and the courage and discipline to carry on.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?9860fff6